import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import tokens from '../theme/tokens';

// 출발지 → 도착지 — 상호와 짧은 주소(서버가 안내문을 떼고 지번·도로명·건물까지만 준다)
const useStyles = makeStyles(() => ({
  root: {
    padding: '18px 20px',
    borderRadius: tokens.radiusLg,
    backgroundColor: tokens.surface,
    boxShadow: tokens.cardShadow,
  },
  row: {
    position: 'relative',
    display: 'flex',
    gap: 14,
    alignItems: 'flex-start',
    '& + &': { marginTop: 14, paddingTop: 14 },
    '& + &:before': {
      content: '""',
      position: 'absolute',
      left: 17,
      top: -16,
      height: 18,
      borderLeft: `2px dashed ${tokens.line}`,
    },
  },
  tag: {
    flex: '0 0 36px',
    height: 36,
    borderRadius: 18,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: -0.4,
    color: tokens.surface,
    backgroundColor: tokens.ink,
  },
  tagTo: { backgroundColor: tokens.primaryDark },
  body: { flex: 1, minWidth: 0, paddingTop: 2 },
  company: {
    display: 'block',
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: -0.6,
    color: tokens.ink,
    lineHeight: 1.4,
    wordBreak: 'keep-all',
  },
  addr: {
    display: 'block',
    marginTop: 2,
    fontSize: 13,
    lineHeight: 1.55,
    letterSpacing: -0.4,
    color: tokens.muted,
    wordBreak: 'keep-all',
  },
}));

function Spot({ cs, tagClass, label, spot }) {
  const company = spot && spot.company;
  const addr = spot && spot.address;
  const dong = spot && spot.dong;
  return (
    <div className={cs.row}>
      <span className={`${cs.tag} ${tagClass || ''}`}>{label}</span>
      <div className={cs.body}>
        <span className={cs.company}>{company || dong || '-'}</span>
        {(addr || (company && dong)) && <span className={cs.addr}>{addr || dong}</span>}
      </div>
    </div>
  );
}

function TrackSpots({ from, to }) {
  const cs = useStyles();
  return (
    <section className={cs.root}>
      <Spot cs={cs} label="출발" spot={from} />
      <Spot cs={cs} tagClass={cs.tagTo} label="도착" spot={to} />
    </section>
  );
}

export default TrackSpots;
